// Keep supplement identity separate from product identity; labels are never parsed.
export function stockSupplementSelections(selectedSupplements, existingSelections = null) {
  if (!Array.isArray(selectedSupplements)) return existingSelections || null;
  if (!selectedSupplements.length) return existingSelections || null;
  return selectedSupplements.map(supplement => ({
    kind: 'supplement',
    id: supplement.id,
    name: supplement.name,
    price: Number(supplement.price || 0),
    image: supplement.image || '',
    categoryName: supplement.SupplementCategory?.name || supplement.categoryName || '',
  }));
}
